// API
// Details for Storefront API.
const storefrontAccessToken = {
    prod: '749d423e57e9c6317eda5fa67cd12c02',
  };
  
  function getAccessToken() {
    switch(Shopify.shop) {
        case 'vanpoelgeest.myshopify.com':
            return storefrontAccessToken.prod
        default:
            return storefrontAccessToken.prod
    }
  }
  
  
  const headers = {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': getAccessToken()
  };
  

  const LOCATION_QUERY = `
    variants(first: 250) {
      edges {
        node {
          id
          availableForSale
          storeAvailability(first: 100) {
            edges {
              node {
                available
                location {
                  id
                  name
                }
                quantityAvailable
              }
            }
          }
        }
      }
    }
  `

  
  function transformGraphqlVariant(productNode) {
      if (!productNode) {
        return null;
      }
    
      const variants = productNode.variants.edges.map(({ node }) => {
        return {
          id: parseInt(node.id.replace('gid://shopify/ProductVariant/', '')),
          available: node.availableForSale,
          store_availability: node.storeAvailability.edges.map(node => {
            const location = {
                ...node.node.location,
                id: parseInt(node.node.location.id.replace('gid://shopify/Location/', '')),
                name: node.node.location.name
            };
            return {
                available: node.node.available,
                location: location,
                quantity: node.node.quantityAvailable
            };
        })
        }
      });
    
      return {
        objectType: 'product',
        id: parseInt(productNode.id.replace('gid://shopify/Product/', '')),
        variants
      };
  }
  
  function transformGraphqlLocation(locationNode) {
      if (!locationNode) {
        return null;
      }
  
      const location = locationNode.edges.map(({ node }) => {
        return {
          id: parseInt(node.id.replace('gid://shopify/Location/', '')),
          name: node.name,
          address: node.address,
          link: node.metafield?.value
        };
      });
    
      return {
        objectType: 'location',
        location
      };
  }
